/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import styles from './index.module.less';
import webview from '../../utils/webview';
import { getSuccessOrder } from '../../services/api'
import { milliFormat, phoneNumFormat, parseDate } from '../../utils/tool';

export default class RechargeSuccess extends Component {
    state = {
        orderItem: '',
        orderStatus: {
            '30': 'Đang xử lý',
            '31': 'Thành công',
            '32': 'Thất bại',
            '33': 'Thành công một phần',
        },
    }

    componentDidMount() {
        console.log(window.location.href);
        let orderId = decodeURI(window.location.href).match(/orderid=(\s*\d+)/);
        if (orderId && orderId[1]) {
            this.getSuccessOrderById(orderId[1].trim());
        }
    }

    getSuccessOrderById(id) {
        getSuccessOrder({ "order_id": id }, {
            "app-id": 1,
            "user-id": '',
            "token": '',
        }).then(res => {
            if (res && res.code === 0) {
                const { data } = res;
                if (data) {
                    this.setState({
                        orderItem: data
                    });
                }
            }
        });
    }

    render() {
        const { orderItem, orderStatus } = this.state;

        return <>
            <div className={styles.successTitle}>Thành công</div>
            <div className={styles.orderInfo}>
                {orderItem ? <div className={styles.historyItem}>
                    <div className={styles.historyTitle}>
                        <span className={styles.orderNum}>{orderItem.order_code}</span>
                        <span className={styles.orderDate}>{parseDate(orderItem.create_time)}</span>
                    </div>
                    <div className={styles.historyContent}>
                        <label>Số điện thoại: <span>{`${orderItem.topup_phone} (${orderItem.vendor})`}</span></label>
                        <label>Mệnh giá：<span>{milliFormat(orderItem.topup_amount)}đ</span></label>
                        <label>Số tiền thanh toán：<span>{milliFormat(orderItem.product_price)}đ</span></label>
                        <label>Trạng thái：<span>{`${orderItem.status}${orderStatus[orderItem.status] ? `,${orderStatus[orderItem.status]}` : ''}`}</span></label>
                        <label>Thời gian nạp：<span>{parseDate(orderItem.update_time)}</span></label>
                        {orderItem.remark ? <label>Mô tả：<span>{orderItem.remark}</span></label> : null}
                    </div>
                </div> : null}
            </div>
        </ >
    }
}